import React, {useEffect, useState} from 'react';

import {useLoaderData, useNavigation, useLocation} from "react-router-dom";

import {isMobile} from "react-device-detect";

import {hasFullAccess} from 'ultra/helpers/auth';
import {DEFAULT_CITY} from 'ultra/const/general';
import {getClientCity, getCityConfig} from 'ultra/configs/general';

import {attachNodeImage} from '../../Helpers/user';
import {useGlobalCustomContext} from '../../../../Helpers/context';
import {getNetworking} from '../../Helpers/networking';

import {useConfigStore} from '../../../../Stores/config';

import PreloaderTable from '../../../../Components/Preloaders/PreloaderTable';

import TableView from '../../../Content/Widgets/Table';
import BreadcrumbsWidget from '../../../Content/Widgets/Breadcrumbs';
import TitleWidget from '../../../Content/Widgets/Title';
// import FiltersLine from '../../../Content/Widgets/FiltersLine';
import NodeInlineActions from '../../../Content/Widgets/NodeInlineActions';

import {NODE_ACTIONS} from '../../../Content/Reducers/node';
import { setPageTitle } from '../../../../Helpers/router';

import './index.scss';

const TITLE = 'Нетворкінг';

export default () => {
    const rawNodes = useLoaderData();

    const navigation = useNavigation();
    const {configs} = useConfigStore();
    const location = useLocation();

    const {nodeState, nodeDispatch} = useGlobalCustomContext();
    const {userState} = useGlobalCustomContext();

    const [city] = useState(getClientCity(window) || DEFAULT_CITY);

    const [nodes, setNodes] = useState();
    const [tableOptions, setTableOptions] = useState();
    const [fields, setFields] = useState();
    const [config, setConfig] = useState();
    const [permits, setPermits] = useState();

    useEffect(() => {
        const fields = attachNodeImage(configs.content.nodes['networking'].fields);
        fields.title.placeholder = 'Користувач';
        fields.title.type = 'networking-link';

        setFields(fields);

        setTableOptions(isMobile ? {
            visible: ['thumbnail', 'title'],
            hidden: ['_created_by', 'region', 'direction', 'messenger', 'description']
        } : {
            visible: ['thumbnail', 'title', 'direction', 'region'],
            hidden: ['messenger', 'description']
        })

        setPermits({
            children: {
                delete: ['networking'],
                update: ['networking'],
                create: ['networking'],
                read: ['networking'],
                validate: ['networking'],
            }
        })
    }, [])

    useEffect(() => {
        if (nodeState.updatePageContentStart) {
            nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_END});
            getNetworking(city, location.search)
                .promise
                .then(setNodes)
        }
    }, [nodeState])

    useEffect(() => {
        if (navigation.state === 'idle') {
            setNodes(rawNodes);
        }
        setPageTitle(TITLE)
    }, [navigation])

    useEffect(() => {
        let networkingCities = []
        // if (userState?.user?.nodes) {
        //     Object.keys(userState.user.nodes.singleton).map(city => {
        //         if (userState.user.nodes.singleton[city]['networking']) networkingCities.push(city)
        //     })
        // }
        if (configs?.content?.cities) {
            Object.keys(configs.content.cities).map(city => {
                if (!configs.content.cities[city].inProgress) networkingCities.push(city);
            });
        }

        const config = {
            showFilters: {
                filterBy: [
                    {
                        id: 'city',
                        field: {
                            type: "city",
                            list: networkingCities
                        }
                    },
                    {
                        id: 'nodes',
                        field: {
                            default: 'published',
                            type: "complex",
                            placeholder: "Статус",
                            options: {
                                hasNoEmptyValue: true,
                            },
                            values: {
                                values: {
                                        published: "Опубліковано",
                                        not_published: "Не опубліковано",
                                    }
                            }
                        }
                    },
                    {
                        id: 'direction',
                        field: {
                            type: "filter",
                            placeholder: "Тип",
                            source: "networking-directions",
                        }
                    }
                ]
            }
        }

        if (configs) {
            setConfig({...config})
        }
    }, [userState?.user, configs])

    const selectClasses = (data) => {}

    const content = {title: TITLE}

    const breadcrumbs = {
        '\\': {
            title: getCityConfig(configs, city).city || 'Головна'
        }
    }

    return <div id="Content" className='Content'>
            <div className='NetworkingPage'>
                <TitleWidget permits={permits} content={content} config={config} breadcrumbs={breadcrumbs} />
                {content?.title && <BreadcrumbsWidget links={breadcrumbs} />}

                {!fields && <PreloaderTable/>}

                {fields && nodes && <TableView
                    showPreloader={!nodes?.list}
                    content={nodes}
                    fields={fields}
                    showPagination={true}
                    tableOptions={tableOptions}
                    actions={(id) => NodeInlineActions({
                        permits: nodes.permits[id],
                        node: nodes.list[id],
                        unfolded: isMobile ? true : false,
                        city,
                        hasFullAccess: hasFullAccess(userState.user)
                    })}
                    selectClasses={selectClasses}
                />}
            </div>
        </div>
}
